/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Modal, Dropdown, Label, Icon, List, Popup, Button
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import Update from 'immutability-helper';
import { withTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';
import CreateJiraIssueModal from '../Jira/CreateJiraIssueModal';

class EditPolicyModal extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isOpenMEP: props.isOpenMEP,
      isOpenMCI: false,
      //policyId: props.policyId,
      isOpenMDP: false,
      isOpenMDJ: false,
      isLoader: false,
      isLoading: false,
      isModalLoading: false,
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
      isWarnModal: false,
      modalWarnTitle: '',
      modalWarnMsg: '',
      id: '',
      coverage: null,
      coverageStatus: '',
      policyName: '',
      policyNameError: '',
      description: '',
      category: 'component',
      conditionList: [],
      assignedProjects: [],
      assignedMembers: {
        group_list: [],
        member_list: [],
      },
      assignedPolicies: {
        company_policy_list: [],
        project_policy_list: [],
      },
      owner: '',
      info: {
        created: '',
        last_modified: '',
      },
      componentList: [],
      versionList: [],
      riskList: [],
      licenseNameList: [],
      selectedCondition: 'all',
      selectedComponent: '',
      selectedVersion: [],
      selectedVersionList: [],
      selectedSecurity: 'severity',
      selectedSeverity: ['critical'],
      selectedRisk: [],
      selectedLicense: 'family',
      selectedFamily: ['protective'],
      selectedlicenseName: [],
      selectedLitigator: [],
      limit: 25,
      activeIndex: '',
      popupStatus: {
        policyPopup: false,
        memberPopup: false,
      },
      hasJira: false,
    };
    this.handleJiraIssueCallback = this.handleJiraIssueCallback.bind(this);
    this.handleMCIClose = this.handleMCIClose.bind(this);
    this.handleMCIOpen = this.handleMCIOpen.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDescChange = this.handleDescChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleComponentChange = this.handleComponentChange.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.handleRemoveCondition = this.handleRemoveCondition.bind(this);
    this.handleComponentSearchChange = this.handleComponentSearchChange.bind(this);
    this.handleVersionSearchChange = this.handleVersionSearchChange.bind(this);
    this.handleCoverageChange = this.handleCoverageChange.bind(this);
    this.handleVersionConditionChange = this.handleVersionConditionChange.bind(this);
    this.handleSecurityConditionChange = this.handleSecurityConditionChange.bind(this);
    this.handleSeverityChange = this.handleSeverityChange.bind(this);
    this.handleRiskChange = this.handleRiskChange.bind(this);
    this.handleRiskSearchChange = this.handleRiskSearchChange.bind(this);
    this.handleLicenseConditionChange = this.handleLicenseConditionChange.bind(this);
    this.handleFamilyChange = this.handleFamilyChange.bind(this);
    this.handleLicenseNameChange = this.handleLicenseNameChange.bind(this);
    this.handleLicenseNameSearchChange = this.handleLicenseNameSearchChange.bind(this);
    this.handleLitigatorConditionChange = this.handleLitigatorConditionChange.bind(this);
    this.handleAddCondition = this.handleAddCondition.bind(this);
    this.handleAddSecurity = this.handleAddSecurity.bind(this);
    this.handleAddLicense = this.handleAddLicense.bind(this);
    this.handleAddLitigator = this.handleAddLitigator.bind(this);
    this.handleRemovePolicy = this.handleRemovePolicy.bind(this);
    this.handleRemoveJira = this.handleRemoveJira.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.closeWarnModal = this.closeWarnModal.bind(this);
    this.closeEditPolicyModal = this.closeEditPolicyModal.bind(this);
    this.clearVersionValue = this.clearVersionValue.bind(this);
    this.clearLitigatorValue = this.clearLitigatorValue.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
    this.closeDeletePolicyModal = this.closeDeletePolicyModal.bind(this);
    this.closeDeleteJiraModal = this.closeDeleteJiraModal.bind(this);
    this.deletesPolicyDetail = this.deletesPolicyDetail.bind(this);
    this.deleteJiraIssueWithPolicy = this.deleteJiraIssueWithPolicy.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    const { isOpenMEP } = this.props;
    if (prevState.selectedCondition !== this.state.selectedCondition || prevState.selectedComponent !== this.state.selectedComponent) {
      this.setState({
        selectedVersion: [],
        versionList: [],
      });
    }

    if (prevState.selectedSecurity !== this.state.selectedSecurity) {
      if (this.state.selectedSecurity === 'code') {
        this.setState({
          selectedSeverity: [],
        });
      } else {
        this.setState({
          selectedRisk: [],
          riskList: [],
        });
      }
    }

    if (prevState.selectedLicense !== this.state.selectedLicense) {
      if (this.state.selectedLicense === 'name') {
        this.setState({
          selectedFamily: [],
        });
      } else {
        this.setState({
          //selectedLicenseName: [],
          licenseNameList: [],
        });
      }
    }

    if (prevProps.isOpenMEP !== isOpenMEP) {
      this.setState({
        id: '',
        coverage: null,
        policyName: '',
        description: '',
        category: 'component',
        conditionList: [],
        assignedProjects: [],
        policyNameError: '',
        owner: '',
        info: {
          created: '',
          last_modified: '',
        },
        componentList: [],
        versionList: [],
        riskList: [],
        licenseNameList: [],
        selectedCondition: 'all',
        selectedComponent: '',
        selectedVersion: [],
        selectedVersionList: [],
        selectedSecurity: 'severity',
        selectedSeverity: ['critical'],
        selectedRisk: [],
        selectedLicense: 'family',
        selectedFamily: ['protective'],
        selectedlicenseName: [],
        selectedLitigator: [],
        assignedMembers: {
          group_list: [],
          member_list: [],
        },
        assignedPolicies: {
          company_policy_list: [],
          project_policy_list: [],
        },
        activeIndex: '',
        popupStatus: {
          policyPopup: false,
          memberPopup: false,
        },
        coverageStatus: '',
        isOpenMEP,
        isOpenMDJ: false,
        hasJira: false,
        isModalLoading: false,
      }, () => {
        if (isOpenMEP) {
          this.getSPolicyDetail(this.props);
        }
      });
    }
  }

  handleScroll = () => {
    const { popupStatus } = this.state;
    if (popupStatus.policyPopup || popupStatus.memberPopup) {
      this.handlePopupClose();
    }
  };

  handlePopupClose() {
    const status = {
      policyPopup: false,
      memberPopup: false,
    };

    this.setState({
      popupStatus: status,
      activeIndex: '',
    });
  }

  handleChange() {
    const { coverageStatus } = this.state;
    if (coverageStatus === 'project') {
      this.setState({
        coverage: coverageStatus,
        isWarnModal: false,
        modalWarnTitle: '',
        modalWarnMsg: '',
        assignedProjects: [],
      });
    } else {
      this.setState({
        coverage: coverageStatus,
        isWarnModal: false,
        modalWarnTitle: '',
        modalWarnMsg: '',
      });
    }
  }

  handleCoverageChange(e, data) {
    const { translate } = this.props;
    const { coverage } = this.state;
    if (coverage !== data.value) {
      if (data.value === 'project') {
        this.setState({
          isWarnModal: true,
          modalWarnTitle: translate('modal.title.attention'),
          modalWarnMsg: translate('settings.message.coverage_company_project'),
          coverageStatus: data.value,
        });
      } else {
        this.setState({
          isWarnModal: true,
          modalWarnTitle: translate('modal.title.attention'),
          modalWarnMsg: translate('settings.message.change_coverage_project'),
          coverageStatus: data.value,
        });
      }
    }
    return false;
  }

  handleNameChange(e) {
    this.setState({
      policyName: e.target.value,
      policyNameError: '',
    });
  }

  handleDescChange(e) {
    this.setState({
      description: e.target.value,
    });
  }

  handleComponentChange = (e, { value }) => {
    const sanitizedSearchQuery = value.replace(/\/\//g, '').toLowerCase();
    this.setState({
      selectedComponent: sanitizedSearchQuery,
      selectedCondition: 'all',
      selectedVersion: [],
      selectedVersionList: [],
    });
  };

  handleComponentSearchChange = this.debounce((e, { searchQuery }) => {
    if (!searchQuery) {
      return;
    }
    const sanitizedSearchQuery = searchQuery.replace(/\/\//g, '').toLowerCase();
    this.setState({ componentList: [] }, () => {
      this.searchPolicyComponent(sanitizedSearchQuery);
    });
  }, 1000);

  handleVersionChange = (e, { value }) => {
    const { selectedVersionList, selectedCondition } = this.state;
    if (selectedCondition === 'specific') {
      if (selectedVersionList.indexOf(value) > -1) {
        return false;
      }
      const newState = [...selectedVersionList, value];
      this.setState({
        selectedVersionList: newState,
        selectedVersion: [],
      });
    } else {
      this.setState({
        selectedVersion: [value],
      });
    }
  };

  handleVersionSearchChange = this.debounce((e, { searchQuery }) => {
    this.setState({ versionList: [] }, () => {
      this.searchPolicyVersion(searchQuery);
    });
  }, 1000);

  handleVersionConditionChange = (e, { value }) => {
    this.setState({
      selectedCondition: value,
      selectedVersion: [],
      selectedVersionList: [],
    });
  };

  handleSecurityConditionChange = (e, { value }) => {
    this.setState({
      selectedSecurity: value,
    });
  };

  handleSeverityChange = (e, { value }) => {
    this.setState({
      selectedSeverity: [value],
    });
  };

  handleRiskChange = (e, { value }) => {
    this.setState({
      selectedRisk: [value],
    });
  };

  handleRiskSearchChange = this.debounce((e, { searchQuery }) => {
    this.setState({ riskList: [] }, () => {
      this.searchPolicyRisk(searchQuery);
    });
  }, 1000);

  handleLicenseConditionChange = (e, { value }) => {
    this.setState({
      selectedLicense: value,
    });
  };

  handleFamilyChange = (e, { value }) => {
    this.setState({
      selectedFamily: [value],
    });
  };

  handleLicenseNameChange = (e, { value }) => {
    this.setState({
      selectedlicenseName: [value],
    });
  };

  handleLicenseNameSearchChange = this.debounce((e, { searchQuery }) => {
    this.setState({ licenseNameList: [] }, () => {
      this.searchPolicyLicense(searchQuery);
    });
  }, 1000);

  handleLitigatorConditionChange = (e, { value }) => {
    this.setState({
      selectedLitigator: [value],
    });
  };

  handleRemoveVersionValue = (index, value) => {
    const { conditionList } = this.state;

    const updatedIndex = conditionList[index].selected_version.findIndex((item) => {
      return item === value;
    });

    const updatedData = Update(conditionList[index], {
      selected_version: {
        $splice: [[updatedIndex, 1]],
      },
    });

    const newData = Update(conditionList, {
      $splice: [[index, 1, updatedData]],
    });

    this.setState({
      conditionList: newData,
      conditionListError: '',
    });
  };

  handleRemoveCondition = (index) => {
    const { conditionList } = this.state;
    this.setState({
      conditionList: Update(
        conditionList,
        {
          $splice: [[index, 1]],
        }
      ),
      conditionListError: '',
    });
  };

  handleRemovePolicy() {
    this.setState({
      isOpenMDP: true,
    });
  }

  handleRemoveJira() {
    const { translate } = this.props;
    this.modalAction = translate('modal.title.attention');
    this.modalBody = translate('settings.message.delete_jira_policy');

    this.setState({
      isOpenMDJ: true,
    });
  }

  handleSave(e) {
    e.preventDefault();
    const {
      id,
      policyName,
      description,
      category,
      coverage,
      conditionList,
    } = this.state;
    const { translate } = this.props;

    const newData = conditionList.filter((item) => {
      if (item.created) {
        delete item.created;
        return item;
      }
      return item;
    });

    const formData = {
      coverage,
      category,
      name: policyName,
      description,
      condition: newData,
    };
    if (!this.validateFields()) {
      return null;
    }

    this.setState({
      modalAlert: true,
      isLoader: true,
    });

    api.updatePolicyDetail(id, formData)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertTitle: translate('modal.title.notice'),
          modalAlertMsg: translate('settings.message.update_policy'),
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-563') {
          return this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('settings.message.limit_company_policy'),
          });
        }
        if (o.error === '422-564') {
          if (this.state.category === 'component') {
            this.setState({
              modalAlertMsg: translate('settings.message.limit_comapy_policy_component'),
            });
          }
          if (this.state.category === 'security') {
            this.setState({
              modalAlertMsg: translate('settings.message.limit_company_policy_security'),
            });
          }
          if (this.state.category === 'license') {
            this.setState({
              modalAlertMsg: translate('settings.message.limit_company_policy_license'),
            });
          }
          if (this.state.category === 'litigator') {
            this.setState({
              modalAlertMsg: translate('settings.message.limit_company_policy_litigator'),
            });
          }
          return this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
          });
        }
        if (o.error === '422-562') {
          return this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('settings.message.duplicated_policy_name'),
          });
        }
        if (o.error === '422-366') {
          return this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description,
          });
        }

        if (o.error_description) {
          this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description,
          });
        } else {
          this.setState({
            isLoader: false,
            isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.unknow_error'),
          });
        }
      });
  }

  handleAddCondition() {
    const {
      selectedComponent, selectedCondition, selectedVersion, selectedVersionList, conditionList
    } = this.state;
    const { translate } = this.props;
    let newObj;
    if (selectedCondition !== 'specific') {
      newObj = {
        component: selectedComponent,
        version_condition: selectedCondition,
        selected_version: selectedVersion,
        id: 0,
      };
      if (selectedCondition === 'all') {
        const checkUnique = this.state.conditionList.filter((item) => {
          return item.component === selectedComponent;
        });
        if (checkUnique.length === 0) {
          this.setState({
            conditionList: [...conditionList, newObj],
            selectedComponent: '',
            selectedCondition: 'all',
            selectedVersionList: [],
            selectedVersion: [],
            conditionListError: '',
          });
        } else {
          this.setState({
            selectedComponent: '',
            selectedCondition: 'all',
            selectedVersionList: [],
            selectedVersion: [],
            conditionListError: translate('settings.message.use_condition'),
          }, () => {
            setTimeout(() => {
              this.setState({
                conditionListError: '',
              });
            }, 1500);
          });
        }
      } else {
        const checkUnique = this.state.conditionList.filter((item) => {
          return item.component === selectedComponent && item.version_condition === selectedCondition && item.selected_version[0] === selectedVersion[0];
        });
        if (checkUnique.length === 0) {
          this.setState({
            conditionList: [...conditionList, newObj],
            selectedComponent: '',
            selectedCondition: 'all',
            selectedVersionList: [],
            selectedVersion: [],
            conditionListError: '',
          });
        } else {
          this.setState({
            selectedComponent: '',
            selectedCondition: 'all',
            selectedVersionList: [],
            selectedVersion: [],
            conditionListError: translate('settings.message.use_condition'),
          }, () => {
            setTimeout(() => {
              this.setState({
                conditionListError: '',
              });
            }, 1500);
          });
        }
      }
    } else {
      newObj = {
        component: selectedComponent,
        version_condition: selectedCondition,
        selected_version: selectedVersionList,
        id: 0,
      };

      const checkUnique = this.state.conditionList.filter((item) => {
        return item.component === selectedComponent && this.isEqual(item.selected_version, selectedVersionList);
      });

      if (checkUnique.length === 0) {
        this.setState({
          conditionList: [...conditionList, newObj],
          selectedComponent: '',
          selectedCondition: 'all',
          selectedVersionList: [],
          selectedVersion: [],
          conditionListError: '',
        });
      } else {
        this.setState({
          selectedComponent: '',
          selectedCondition: 'all',
          selectedVersionList: [],
          selectedVersion: [],
          conditionListError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              conditionListError: '',
            });
          }, 1500);
        });
      }
    }
  }

  handleAddSecurity() {
    const {
      selectedSecurity, selectedSeverity, selectedRisk, conditionList
    } = this.state;
    const { translate } = this.props;
    let newObj;

    if (selectedSecurity === 'severity') {
      const checkUnique = this.state.conditionList.filter((item) => {
        return item.selected[0] === selectedSeverity[0];
      });
      if (checkUnique.length === 0) {
        newObj = {
          security_condition: selectedSecurity,
          selected: selectedSeverity,
          id: 0,
        };
        this.setState({
          conditionList: [...conditionList, newObj],
          selectedSecurity: 'severity',
          selectedSeverity: ['critical'],
          selectedRisk: [],
          conditionListError: '',
        });
      } else {
        this.setState({
          selectedSecurity: 'severity',
          selectedSeverity: ['critical'],
          selectedRisk: [],
          conditionListError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              conditionListError: '',
            });
          }, 1500);
        });
      }
    } else {
      const checkUnique = this.state.conditionList.filter((item) => {
        return item.selected[0] === selectedRisk[0];
      });
      if (checkUnique.length === 0) {
        newObj = {
          security_condition: selectedSecurity,
          selected: selectedRisk,
          id: 0,
        };
        this.setState({
          conditionList: [...conditionList, newObj],
          selectedSecurity: 'severity',
          selectedSeverity: ['critical'],
          selectedRisk: [],
          conditionListError: '',
        });
      } else {
        this.setState({
          selectedSecurity: 'severity',
          selectedSeverity: ['critical'],
          selectedRisk: [],
          conditionListError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              conditionListError: '',
            });
          }, 1500);
        });
      }
    }
  }

  handleAddLicense() {
    const {
      selectedLicense, selectedFamily, selectedlicenseName, conditionList
    } = this.state;
    const { translate } = this.props;
    let newObj;

    if (selectedLicense === 'family') {
      const checkUnique = this.state.conditionList.filter((item) => {
        return item.selected[0] === selectedFamily[0];
      });
      if (checkUnique.length === 0) {
        newObj = {
          license_condition: selectedLicense,
          selected: selectedFamily,
          id: 0,
        };
        this.setState({
          conditionList: [...conditionList, newObj],
          selectedLicense: 'family',
          selectedFamily: ['protective'],
          selectedlicenseName: [],
          conditionListError: '',
        });
      } else {
        this.setState({
          selectedLicense: 'family',
          selectedFamily: ['protective'],
          selectedlicenseName: [],
          conditionListError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              conditionListError: '',
            });
          }, 1500);
        });
      }
    } else {
      const checkUnique = this.state.conditionList.filter((item) => {
        return item.selected[0] === selectedlicenseName[0];
      });
      if (checkUnique.length === 0) {
        newObj = {
          license_condition: selectedLicense,
          selected: selectedlicenseName,
          id: 0,
        };
        this.setState({
          conditionList: [...conditionList, newObj],
          selectedLicense: 'family',
          selectedFamily: ['protective'],
          selectedlicenseName: [],
          conditionListError: '',
        });
      } else {
        this.setState({
          selectedLicense: 'family',
          selectedFamily: ['protective'],
          selectedlicenseName: [],
          conditionListError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              conditionListError: '',
            });
          }, 1500);
        });
      }
    }
  }

  handleAddLitigator() {
    const { selectedLitigator, conditionList } = this.state;
    const { translate } = this.props;
    const checkUnique = this.state.conditionList.filter((item) => {
      return item.selected[0] === selectedLitigator[0];
    });
    if (checkUnique.length === 0) {
      const newObj = {
        selected: selectedLitigator,
        id: 0,
      };

      this.setState({
        conditionList: [...conditionList, newObj],
        selectedLitigator: [],
        conditionListError: '',
      });
    } else {
      this.setState({
        selectedLitigator: [],
        conditionListError: translate('settings.message.use_condition'),
      }, () => {
        setTimeout(() => {
          this.setState({
            conditionListError: '',
          });
        }, 1500);
      });
    }
  }

  handleMCIOpen() {
    this.setState({
      isOpenMCI: true,
    });
  }

  handleMCIClose() {
    this.setState({
      isOpenMCI: false,
    });
  }

  handleJiraIssueCallback() {
    this.setState(
      {
        isOpenMCI: false,
      },
      () => {
        this.getSPolicyDetail(this.props);
      }
    );
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += (text.charCodeAt(i) > 128) ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  getSPolicyDetail(Props) {
    this.setState({
      isLoading: true,
    }, () => {
      api.getSPolicyDetail(Props.policyId)
        .then((response) => {
          const data = response.response;
          this.setState({
            id: data.id,
            coverage: data.coverage,
            policyName: data.name,
            description: data.description,
            category: data.category,
            conditionList: data.condition,
            assignedProjects: data.assinged_projects,
            owner: data.owners,
            info: data.info,
            hasJira: data.has_jira,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  getsProjectPolicyDetail = (projectId) => {
    const status = {
      policyPopup: true,
      memberPopup: false,
    };
    api
      .getsProjectPolicyDetail(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: projectId,
          assignedPolicies: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  };

  getsProjectPolicyMemberDetail = (projectId) => {
    const status = {
      policyPopup: false,
      memberPopup: true,
    };
    api
      .getsProjectPolicyMemberDetail(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: projectId,
          assignedMembers: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  };

  addConditionBtn = (translate) => {
    const {
      selectedComponent, selectedCondition, selectedVersion, selectedVersionList
    } = this.state;

    if (!this.props.state.user.isAdmin) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}
        </a>
      );
    }

    if (selectedCondition === 'all') {
      if (!selectedComponent) {
        return (
          <a
            className="blue_button"
            style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
          >
            {translate('modal.button.add')}
          </a>
        );
      }
      return (
        <a
          className="blue_button"
          style={{ cursor: 'pointer' }}
          onClick={this.handleAddCondition}
          onKeyUp={this.handleAddCondition}
        >
          {translate('modal.button.add')}
        </a>
      );
    } if (selectedCondition === 'specific') {
      if (!selectedComponent || selectedVersionList.length === 0) {
        return (
          <a
            className="blue_button"
            style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
          >
            {translate('modal.button.add')}
          </a>
        );
      }
      return (
        <a
          className="blue_button"
          style={{ cursor: 'pointer' }}
          onClick={this.handleAddCondition}
          onKeyUp={this.handleAddCondition}
        >
          {translate('modal.button.add')}
        </a>
      );
    } if (!selectedComponent || selectedVersion.length === 0) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}
        </a>
      );
    }
    return (
      <a
        className="blue_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleAddCondition}
        onKeyUp={this.handleAddCondition}
      >
        {translate('modal.button.add')}
      </a>
    );
  };

  addSecurityBtn = () => {
    const { selectedSecurity, selectedRisk } = this.state;
    const { translate } = this.props;
    if (!this.props.state.user.isAdmin) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    if (selectedSecurity === 'code' && selectedRisk.length === 0) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    return (
      <a
        className="blue_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleAddSecurity}
        onKeyUp={this.handleAddSecurity}
      >
        {translate('modal.button.add')}

      </a>
    );
  };

  addLicenseBtn = () => {
    const { selectedLicense, selectedlicenseName } = this.state;
    const { translate } = this.props;
    if (!this.props.state.user.isAdmin) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    if (selectedLicense === 'name' && selectedlicenseName.length === 0) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    return (
      <a
        className="blue_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleAddLicense}
        onKeyUp={this.handleAddLicense}
      >
        {translate('modal.button.add')}

      </a>
    );
  };

  addLitigatorBtn = () => {
    const { selectedLitigator } = this.state;
    const { translate } = this.props;
    if (!this.props.state.user.isAdmin) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    if (selectedLitigator.length === 0) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    return (
      <a
        className="blue_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleAddLitigator}
        onKeyUp={this.handleAddLitigator}
      >
        {translate('modal.button.add')}

      </a>
    );
  };

  clearVersionValue = (value) => {
    const { selectedVersionList } = this.state;
    let newState;

    if (selectedVersionList.indexOf(value) > -1) {
      newState = selectedVersionList.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [];
    }

    if (newState.length === 0) {
      this.setState({
        selectedVersionList: [],
        selectedVersion: [],
      });
    } else {
      this.setState({
        selectedVersionList: newState,
      });
    }
  };

  clearLitigatorValue = (value) => {
    const { selectedLitigatorList } = this.state;
    let newState;

    if (selectedLitigatorList.indexOf(value) > -1) {
      newState = selectedLitigatorList.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [];
    }

    if (newState.length === 0) {
      this.setState({
        selectedLitigatorList: [],
        selectedLitigator: [],
      });
    } else {
      this.setState({
        selectedLitigatorList: newState,
      });
    }
  };

  debounce(func, delay) {
    let timer;
    return function debouncedFunction(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => { return func.apply(this, args); }, delay);
    };
  }

  closeWarnModal() {
    this.setState({
      coverageStatus: '',
      isWarnModal: false,
    });
  }

  closeEditPolicyModal(e) {
    if (e) {
      e.preventDefault();
      if (e.target.classList[1] === 'icon' || e.target.classList[1] === 'item' || e.target.classList[0] === 'red_button' || e.target.classList[0] === 'text' || e.target.classList[0] === 'item' || e.target.classList[2] === 'item') {
        return false;
      }
    }
    this.setState({
      isOpenMEP: false,
    });
    this.props.closeModal();
  }

  divideStr(str) {
    if (str.length > 25) {
      return `${str.substr(0, 20)}...`;
    }
    return str;
  }

  validateFields() {
    const { policyName, conditionList } = this.state;
    const { translate } = this.props;

    const validation = {
      policyName: true,
      condition: true,
    };

    if (policyName.trim().length === 0) {
      this.setState({
        policyNameError: translate('settings.message.required_policy'),
      });
      this.policyNM.scrollIntoView();
      this.nameInput.focus();
      validation.policyName = false;
      return false;
    }
    if (this.getByteLength(policyName) > 30) {
      this.setState({
        policyNameError: translate('settings.message.limite_character_policy'),
      });
      this.policyNM.scrollIntoView();
      this.nameInput.focus();
      validation.policyName = false;
      return false;
    }

    if (conditionList.length === 0) {
      this.setState({
        conditionListError: translate('settings.message.select_one_condition'),
      });
      this.condition.scrollIntoView();
      validation.condition = false;
      return false;
    }

    return validation.policyName && validation.condition;
  }

  closeAlertModal() {
    const { translate } = this.props;
    if (this.state.modalAlertTitle.indexOf(translate('modal.title.attention')) > -1) {
      this.setState({
        modalAlert: false,
      });
    } else {
      this.setState(
        {
          modalAlert: false,
        },
        () => {
          this.props.completeCallback(200);
          this.closeEditPolicyModal();
        }
      );
    }
  }

  closeDeleteJiraModal() {
    this.setState({
      isOpenMDJ: false,
      isModalLoading: false,
    });
  }

  closeDeletePolicyModal() {
    this.setState({
      isOpenMDP: false,
    });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  searchPolicyComponent(searchKeyword) {
    const { limit } = this.state;

    console.log(searchKeyword);
    api
      .searchPolicyComponent({
        search: searchKeyword || '',
        limit,
      })
      .then((response) => {
        if (response.count === 0) return;
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            key: index,
            text: item,
            value: item,
          };
        });
        this.setState({
          componentList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  searchPolicyVersion(searchKeyword) {
    const { limit, selectedComponent, editSearchComponent } = this.state;
    if (!editSearchComponent) {
      api
        .searchPolicyVersion({
          search: searchKeyword || '',
          component: selectedComponent,
          limit,
        })
        .then((response) => {
          if (response.count === 0) return;
          const data = response.response;
          const newData = data.map((item, index) => {
            return {
              key: index,
              text: item,
              value: item,
            };
          });
          this.setState({
            versionList: newData,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      api
        .searchPolicyVersion({
          search: searchKeyword || '',
          component: editSearchComponent,
          limit,
        })
        .then((response) => {
          if (response.count === 0) return;
          const data = response.response;
          const newData = data.map((item, index) => {
            return {
              key: index,
              text: item,
              value: item,
            };
          });
          this.setState({
            versionList: newData,
            editSearchComponent: '',
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  searchPolicyRisk(searchKeyword) {
    const { limit } = this.state;
    api
      .searchPolicyRisk({
        search: searchKeyword || '',
        limit,
      })
      .then((response) => {
        if (response.count === 0) return;
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            key: index,
            text: item,
            value: item,
          };
        });
        this.setState({
          riskList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  searchPolicyLicense(searchKeyword) {
    const { limit } = this.state;
    api
      .searchPolicyLicense({
        search: searchKeyword || '',
        limit,
      })
      .then((response) => {
        if (response.count === 0) return;
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            key: index,
            text: item,
            value: item,
          };
        });
        this.setState({
          licenseNameList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  isEqual(a, b) {
    const aCnt = a.length;
    const bCnt = b.length;
    let cNt = 0;
    let i = 0;

    if (aCnt !== bCnt) {
      return false;
    }

    for (i; i < aCnt; i++) {
      let j = 0;
      for (j; j < bCnt; j++) {
        if (a[i] === b[j]) {
          cNt++;
          break;
        }
      }
    }

    if (cNt === aCnt && cNt === bCnt) {
      return true;
    }
    return false;
  }

  deletesPolicyDetail() {
    const { policyId } = this.props;
    api
      .deletesPolicyDetail(policyId)
      .then(() => {
        this.closeDeletePolicyModal();
        this.closeEditPolicyModal();
        this.props.completeCallback(200);
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  }

  deleteJiraIssueWithPolicy() {
    const { policyId, translate } = this.props;
    this.modalAction = translate('modal.title.attention');
    this.modalBody = translate('settings.message.delete_jira_policy');
    api
      .deleteJiraIssueWithPolicy(policyId)
      .then(() => {
        this.modalAction = translate('modal.title.notice');
        this.modalBody = translate('settings.message.success_delete_jira_policy');
        this.setState({
          isModalLoading: true,
        });
        this.getSPolicyDetail(this.props);
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
          isModalLoading: true,
        });
      });
  }

  renderVersionValue = (value) => {
    return (
      <div
        className="text_box"
        style={{ border: '1px solid #cacaca', boxSizing: 'border-box', borderRadius: '5px' }}
      >
        {this.divideStr(value)}
        <Icon
          name="close"
          style={{
            cursor: 'pointer', margin: '0', width: 'inherit', float: 'right'
          }}
          onClick={() => {
            return this.clearVersionValue(value);
          }}
        />
      </div>
    );
  };

  render() {
    const {
      coverage,
      policyName,
      description,
      category,
      assignedProjects,
      owner,
      info,
      componentList,
      versionList,
      riskList,
      licenseNameList,
      selectedComponent,
      selectedCondition,
      selectedVersion,
      selectedVersionList,
      selectedSecurity,
      selectedSeverity,
      selectedRisk,
      selectedLicense,
      selectedFamily,
      selectedlicenseName,
      selectedLitigator,
      conditionList,
      popupStatus,
      activeIndex,
      isLoading,
      isOpenMEP,
      hasJira,
      isOpenMCI,
      isOpenMDP,
      isOpenMDJ,
      isModalLoading,
    } = this.state;

    const { translate, policyId } = this.props;

    const coverageList = [
      { key: 1, text: 'Project', value: 'project' },
      { key: 2, text: 'Company', value: 'company' },
    ];
    const versionConditions = [
      { key: '1', text: translate('settings.list.all_versions'), value: 'all' },
      { key: '2', text: translate('settings.list.and_earlier'), value: 'earlier' },
      { key: '3', text: translate('settings.list.and_later'), value: 'later' },
      { key: '4', text: translate('settings.list.specific_version'), value: 'specific' },
    ];
    const securityConditions = [
      { key: '1', text: translate('settings.list.security_risk_severity'), value: 'severity' },
      { key: '2', text: translate('settings.list.security_risk'), value: 'code' },
    ];
    const severityConditions = [
      { key: '1', text: 'Critical', value: 'critical' },
      { key: '2', text: 'High', value: 'high' },
      { key: '3', text: 'Medium', value: 'medium' },
      { key: '4', text: 'Low', value: 'low' },
    ];
    const licenseConditions = [
      { key: '1', text: translate('list.title.license_family'), value: 'family' },
      { key: '2', text: translate('list.title.license'), value: 'name' },
    ];
    const familyConditions = [
      { key: '1', text: 'Protective', value: 'protective' },
      { key: '2', text: 'Permissive', value: 'permissive' },
      { key: '3', text: 'Others', value: 'others' },
    ];
    const litigatorConditions = [
      { key: '1', text: 'SFC', value: 'sfc' },
      { key: '2', text: 'McHardy', value: 'mchardy' },
      { key: '3', text: 'Patent Module', value: 'patents' },
    ];

    const policyNameErrorClass = this.state.policyNameError !== '' ? 'show' : '';
    const conditionErrorClass = this.state.conditionListError !== '' ? 'show' : '';

    const getModalContent = () => {
      if (isLoading) {
        return <Loader />;
      }
      return (
        <div className="setting_popup_contnets">
          <div className="setting_popup_content_wrap">
            <h4 className="content_title">{translate('settings.list.policy_coverage')}</h4>
            <div className="setting_popup_content">
              <div className="small_box">
                {
                  coverage
                    && (
                      <Dropdown
                        options={coverageList}
                        defaultValue={coverage}
                        onChange={this.handleCoverageChange}
                        style={{ width: '50%' }}
                        disabled={!this.props.state.user.isAdmin}
                      />
                    )
                }
                {coverage === 'company' && (
                  <Label basic pointing>
                    {translate('settings.message.company_policy')}
                  </Label>
                )}
              </div>
            </div>
          </div>
          <div className="setting_popup_content_wrap">
            <h4
              className="content_title"
              ref={(ref) => {
                this.policyNM = ref;
              }}

            >
              {translate('settings.list.policy_name')}
              <em style={{ marginLeft: '0' }} className="asterisk" />
            </h4>
            <div className="setting_popup_content">
              <input
                type="text"
                placeholder={translate('settings.list.policy_name')}
                ref={(ref) => {
                  this.nameInput = ref;
                }}
                value={policyName}
                onChange={this.handleNameChange}
                readOnly={!this.props.state.user.isAdmin}
              />
              <div
                className={`error ${policyNameErrorClass}`}
                style={{
                  marginTop: '6px',
                  marginLeft: '5px',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {this.state.policyNameError}
              </div>
            </div>
          </div>
          <div className="setting_popup_content_wrap">
            <h4 className="content_title">{translate('list.title.description')}</h4>
            <div className="setting_popup_content">
              <textarea
                value={description}
                placeholder={translate('list.title.description')}
                onChange={this.handleDescChange}
                rows="3"
                readOnly={!this.props.state.user.isAdmin}
              />
            </div>
          </div>
          <div className="setting_popup_content_wrap">
            <h4 className="content_title">{translate('settings.list.category')}</h4>
            <div className="setting_popup_content">
              <div className="small_box">
                <div className="switch button_4">
                  <a
                    style={{ pointerEvents: 'none', cursor: 'default' }}
                    className={category.indexOf('component') > -1 ? 'checked' : null}
                  >
                    {translate('project.menu.component')}
                  </a>
                  <a
                    style={{ pointerEvents: 'none', cursor: 'default' }}
                    className={category.indexOf('security') > -1 ? 'checked' : null}
                  >
                    {translate('project.menu.security')}
                  </a>
                  <a
                    style={{ pointerEvents: 'none', cursor: 'default' }}
                    className={category.indexOf('license') > -1 ? 'checked' : null}
                  >
                    {translate('project.menu.license')}
                  </a>
                  <a
                    style={{ pointerEvents: 'none', cursor: 'default' }}
                    className={category.indexOf('litigator') > -1 ? 'checked' : null}
                  >
                    {translate('project.menu.litigator')}
                  </a>
                </div>
              </div>
            </div>
          </div>
          {category.indexOf('component') > -1 && (
            <div className="setting_popup_content_wrap" style={{ tableLayout: 'fixed' }}>
              <h4
                className="content_title"
                ref={(ref) => {
                  this.condition = ref;
                }}
              >
                {translate('settings.list.condition')}
                <em style={{ marginLeft: '0' }} className="asterisk" />
              </h4>
              <div
                className={`error ${conditionErrorClass}`}
                style={{
                  marginTop: '6px',
                  marginLeft: '5px',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {this.state.conditionListError}
              </div>
              <div className="setting_popup_content">
                <table className="table">
                  <colgroup>
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '10%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.component_placeholder')}
                          onChange={this.handleComponentChange}
                          onFocus={this.handleComponentSearchChange}
                          onSearchChange={this.handleComponentSearchChange}
                          options={componentList}
                          search
                          selection
                          value={selectedComponent}
                          disabled={!this.props.state.user.isAdmin}
                        />
                      </td>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.condition_placeholder')}
                          disabled={!selectedComponent || !this.props.state.user.isAdmin}
                          options={versionConditions}
                          value={selectedCondition}
                          onChange={this.handleVersionConditionChange}
                          selection
                        />
                      </td>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.version_placeholder')}
                          disabled={!selectedComponent || selectedCondition === 'all' || !this.props.state.user.isAdmin}
                          onSearchChange={this.handleVersionSearchChange}
                          options={versionList}
                          style={{ width: '232px' }}
                          openOnFocus
                          search
                          selection
                          value={selectedVersion[0]}
                        />
                      </td>
                      <td>&nbsp;</td>
                      <td>
                        {
                          translate && this.addConditionBtn(translate)
                        }
                      </td>
                    </tr>
                    {
                      selectedVersionList.length !== 0 ? (
                        selectedVersionList.map((item) => {
                          return (
                            <tr key={uuidv4()}>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td style={{ paddingTop: '5px' }}>{this.renderVersionValue(item)}</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                          );
                        })
                      ) : null
                    }
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {category.indexOf('security') > -1 && (
            <div className="setting_popup_content_wrap" style={{ tableLayout: 'fixed' }}>
              <h4 className="content_title">
                {translate('settings.list.condition')}
                <em style={{ marginLeft: '0' }} className="asterisk" />
              </h4>
              <div
                className={`error ${conditionErrorClass}`}
                style={{
                  marginTop: '6px',
                  marginLeft: '5px',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {this.state.conditionListError}
              </div>
              <div className="setting_popup_content">
                <table className="table">
                  <colgroup>
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '10%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.security_condition_placeholder')}
                          options={securityConditions}
                          value={selectedSecurity}
                          onChange={this.handleSecurityConditionChange}
                          selection
                          disabled={!this.props.state.user.isAdmin}
                        />
                      </td>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.security_condition_placeholder')}
                          disabled={selectedSecurity === 'code' || !this.props.state.user.isAdmin}
                          options={severityConditions}
                          value={selectedSeverity[0]}
                          onChange={this.handleSeverityChange}
                          selection
                        />
                      </td>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.search_risk_placeholder')}
                          onChange={this.handleRiskChange}
                          onFocus={this.handleRiskSearchChange}
                          onSearchChange={this.handleRiskSearchChange}
                          onOpen={this.handleRiskSearchChange}
                          options={riskList}
                          search
                          selection
                          value={selectedRisk[0]}
                          disabled={selectedSecurity === 'severity' || !this.props.state.user.isAdmin}
                        />
                      </td>
                      <td>&nbsp;</td>
                      <td>
                        {
                          this.addSecurityBtn()
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {category.indexOf('license') > -1 && (
            <div className="setting_popup_content_wrap" style={{ tableLayout: 'fixed' }}>
              <h4 className="content_title">
                {translate('settings.list.condition')}
                <em style={{ marginLeft: '0' }} className="asterisk" />
              </h4>
              <div
                className={`error ${conditionErrorClass}`}
                style={{
                  marginTop: '6px',
                  marginLeft: '5px',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {this.state.conditionListError}
              </div>
              <div className="setting_popup_content">
                <table className="table">
                  <colgroup>
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '10%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.license_condition_placeholder')}
                          options={licenseConditions}
                          value={selectedLicense}
                          onChange={this.handleLicenseConditionChange}
                          selection
                          disabled={!this.props.state.user.isAdmin}
                        />
                      </td>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.security_condition_placeholder')}
                          disabled={selectedLicense === 'name' || !this.props.state.user.isAdmin}
                          options={familyConditions}
                          value={selectedFamily[0]}
                          onChange={this.handleFamilyChange}
                          selection
                        />
                      </td>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.select_license_placeholder')}
                          onChange={this.handleLicenseNameChange}
                          onFocus={this.handleLicenseNameSearchChange}
                          onSearchChange={this.handleLicenseNameSearchChange}
                          onOpen={this.handleLicenseNameSearchChange}
                          options={licenseNameList}
                          search
                          selection
                          value={selectedlicenseName[0]}
                          disabled={selectedLicense === 'family' || !this.props.state.user.isAdmin}
                        />
                      </td>
                      <td>&nbsp;</td>
                      <td>
                        {
                          this.addLicenseBtn()
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {category.indexOf('litigator') > -1 && (
            <div className="setting_popup_content_wrap" style={{ tableLayout: 'fixed' }}>
              <h4 className="content_title">
                {translate('settings.list.condition')}
                <em style={{ marginLeft: '0' }} className="asterisk" />
              </h4>
              <div
                className={`error ${conditionErrorClass}`}
                style={{
                  marginTop: '6px',
                  marginLeft: '5px',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {this.state.conditionListError}
              </div>
              <div className="setting_popup_content">
                <table className="table">
                  <colgroup>
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '25%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '10%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <Dropdown
                          placeholder={translate('settings.message.select_litigator_placeholder')}
                          options={litigatorConditions}
                          value={selectedLitigator[0]}
                          onChange={this.handleLitigatorConditionChange}
                          selection
                          disabled={!this.props.state.user.isAdmin}
                        />
                      </td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>
                        {
                          this.addLitigatorBtn()
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="setting_popup_content_wrap">
            <h4 className="content_title">{translate('settings.list.selected_condition')}</h4>
            <div className="setting_popup_content">
              <table className="table" style={{ tableLayout: 'fixed' }}>
                <colgroup>
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '10%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th style={{ textAlign: 'center' }}>{translate('settings.list.condtion_name')}</th>
                    <th>&nbsp;</th>
                    <th>&nbsp;</th>
                    <th style={{ textAlign: 'center' }}>{translate('settings.list.created_date')}</th>
                    <th>&nbsp;</th>
                  </tr>
                  {
                    category.indexOf('component') > -1
                    && conditionList.map((item, i) => {
                      if (item.version_condition === 'specific') {
                        return (
                          <tr key={uuidv4()}>
                            <td colSpan="5" style={{ padding: '0', border: 'none' }}>
                              <table style={{ width: '100%', tableLayout: 'fixed' }}>
                                <colgroup>
                                  <col style={{ width: '25%' }} />
                                  <col style={{ width: '25%' }} />
                                  <col style={{ width: '25%' }} />
                                  <col style={{ width: '15%' }} />
                                  <col style={{ width: '10%' }} />
                                </colgroup>
                                <tbody>
                                  <tr>
                                    <td style={{ paddingTop: '5px' }}>
                                      <div className="edit_box not">
                                        {item.component}
                                      </div>
                                    </td>
                                    <td style={{ paddingTop: '5px' }}>
                                      <div className="edit_box not">
                                        {this.divideStr(item.version_condition)}
                                      </div>
                                    </td>
                                    <td style={{ paddingTop: '5px' }}>
                                      <div
                                        className="edit_box not"
                                      >
                                        {this.divideStr(item.selected_version[0])}
                                        {
                                          item.selected_version.length > 1 && this.props.state.user.isAdmin ? (
                                            <Icon
                                              name="close"
                                              style={{
                                                cursor: 'pointer', margin: '0', width: 'inherit', float: 'right'
                                              }}
                                              onClick={() => {
                                                return this.handleRemoveVersionValue(i, item.selected_version[0]);
                                              }}
                                            />
                                          ) : null
                                        }
                                      </div>
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                      {
                                        item.created === 0 ? (
                                          '-'
                                        ) : (
                                          item.created
                                        )
                                      }
                                    </td>
                                    <td style={{ paddingTop: '5px' }}>
                                      {
                                        this.props.state.user.isAdmin ? (
                                          <a
                                            className="red_button"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                              return this.handleRemoveCondition(i);
                                            }}
                                            onKeyUp={() => {
                                              return this.handleRemoveCondition(i);
                                            }}
                                          >
                                            {translate('modal.button.delete')}
                                          </a>
                                        ) : (
                                          <a
                                            className="red_button"
                                            style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                          >
                                            {translate('modal.button.delete')}
                                          </a>
                                        )
                                      }
                                    </td>
                                  </tr>
                                  {
                                    item.selected_version.length > 1 ? (
                                      item.selected_version.map((nested, l) => {
                                        if (l > 0) {
                                          return (
                                            <tr key={uuidv4()}>
                                              <td>&nbsp;</td>
                                              <td>&nbsp;</td>
                                              <td style={{ paddingTop: '5px' }}>
                                                <div className="edit_box not">
                                                  {this.divideStr(nested)}
                                                  {
                                                    this.props.state.user.isAdmin ? (
                                                      <Icon
                                                        name="close"
                                                        style={{
                                                          cursor: 'pointer', margin: '0', width: 'inherit', float: 'right'
                                                        }}
                                                        onClick={() => {
                                                          return this.handleRemoveVersionValue(i, item.selected_version[l]);
                                                        }}
                                                      />
                                                    ) : null
                                                  }
                                                </div>
                                              </td>
                                              <td>&nbsp;</td>
                                              <td>&nbsp;</td>
                                            </tr>
                                          );
                                        }
                                        return null;
                                      })
                                    ) : null
                                  }
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        );
                      }
                      if (item.version_condition === 'all') {
                        return (
                          <tr key={uuidv4()}>
                            <td style={{ paddingTop: '5px' }}>
                              <div className="edit_box not">
                                {item.component}
                              </div>
                            </td>
                            <td style={{ paddingTop: '5px' }}>
                              <div className="edit_box not">
                                {item.version_condition}
                              </div>
                            </td>
                            <td style={{ paddingTop: '5px' }}>&nbsp;</td>
                            <td style={{ textAlign: 'center' }}>
                              {
                                item.created === 0 ? ('-') : (
                                  item.created
                                )
                              }
                            </td>
                            <td>
                              {
                                this.props.state.user.isAdmin ? (
                                  <a
                                    className="red_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                ) : (
                                  <a
                                    className="red_button"
                                    style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                )
                              }
                            </td>
                          </tr>
                        );
                      }
                      return (
                        <tr key={uuidv4()}>
                          <td style={{ paddingTop: '5px' }}>
                            <div className="edit_box not">
                              {item.component}
                            </div>
                          </td>
                          <td style={{ paddingTop: '5px' }}>
                            <div className="edit_box not">
                              {item.version_condition}
                            </div>
                          </td>
                          <td style={{ paddingTop: '5px' }}>
                            <div className="edit_box not">
                              {this.divideStr(item.selected_version[0])}
                            </div>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {
                              item.created === 0 ? (
                                '-'
                              ) : (
                                item.created
                              )
                            }
                          </td>
                          <td>
                            {
                              this.props.state.user.isAdmin ? (
                                <a
                                  className="red_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                  onKeyUp={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              ) : (
                                <a
                                  className="red_button"
                                  style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              )
                            }
                          </td>
                        </tr>
                      );
                    })
                  }
                  {
                    category.indexOf('security') > -1
                    && conditionList.map((item, i) => {
                      if (item.security_condition === 'severity') {
                        return (
                          <tr key={uuidv4()}>
                            <td style={{ paddingTop: '5px' }}>
                              <div className="edit_box not">
                                {
                                  item.security_condition === 'severity' && 'Security Risk Severity'
                                }
                                {
                                  item.security_condition === 'code' && 'Security Risk'
                                }
                              </div>
                            </td>
                            <td style={{ paddingTop: '5px' }}>
                              <div className="edit_box not">
                                {
                                  item.selected[0] === 'critical' && 'Critical'
                                }
                                {
                                  item.selected[0] === 'high' && 'High'
                                }
                                {
                                  item.selected[0] === 'medium' && 'Medium'
                                }
                                {
                                  item.selected[0] === 'low' && 'Low'
                                }
                              </div>
                            </td>
                            <td>&nbsp;</td>
                            <td style={{ textAlign: 'center' }}>
                              {
                                item.created === 0 ? (
                                  '-'
                                ) : (
                                  item.created
                                )
                              }
                            </td>
                            <td style={{ paddingTop: '5px' }}>
                              {
                                this.props.state.user.isAdmin ? (
                                  <a
                                    className="red_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                ) : (
                                  <a
                                    className="red_button"
                                    style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                )
                              }
                            </td>
                          </tr>
                        );
                      }
                      return (
                        <tr key={uuidv4()}>
                          <td style={{ paddingTop: '5px' }}>
                            <div className="edit_box not">
                              {
                                item.security_condition === 'severity' && 'Security Risk Severity'
                              }
                              {
                                item.security_condition === 'code' && 'Security Risk'
                              }
                            </div>
                          </td>
                          <td>&nbsp;</td>
                          <td style={{ paddingTop: '5px' }}>
                            <div className="edit_box not">
                              {item.selected[0]}
                            </div>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {
                              item.created === 0 ? (
                                '-'
                              ) : (
                                item.created
                              )
                            }
                          </td>
                          <td style={{ paddingTop: '5px' }}>
                            {
                              this.props.state.user.isAdmin ? (
                                <a
                                  className="red_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                  onKeyUp={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              ) : (
                                <a
                                  className="red_button"
                                  style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              )
                            }
                          </td>
                        </tr>
                      );
                    })
                  }
                  {
                    category.indexOf('license') > -1
                    && conditionList.map((item, i) => {
                      if (item.license_condition === 'family') {
                        return (
                          <tr key={uuidv4()}>
                            <td style={{ paddingTop: '5px' }}>
                              <div className="edit_box not">
                                {
                                  item.license_condition === 'family' && 'License Family'
                                }
                                {
                                  item.license_condition === 'name' && 'License'
                                }
                              </div>
                            </td>
                            <td style={{ paddingTop: '5px' }}>
                              <div className="edit_box not">
                                {
                                  item.selected[0] === 'protective' && 'Protective'
                                }
                                {
                                  item.selected[0] === 'permissive' && 'Permissive'
                                }
                                {
                                  item.selected[0] === 'others' && 'Others'
                                }
                              </div>
                            </td>
                            <td>&nbsp;</td>
                            <td style={{ textAlign: 'center' }}>
                              {
                                item.created === 0 ? (
                                  '-'
                                ) : (
                                  item.created
                                )
                              }
                            </td>
                            <td style={{ paddingTop: '5px' }}>
                              {
                                this.props.state.user.isAdmin ? (
                                  <a
                                    className="red_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                ) : (
                                  <a
                                    className="red_button"
                                    style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                )
                              }
                            </td>
                          </tr>
                        );
                      }
                      return (
                        <tr key={uuidv4()}>
                          <td style={{ paddingTop: '5px' }}>
                            <div className="edit_box not">
                              {
                                item.license_condition === 'family' && 'License Family'
                              }
                              {
                                item.license_condition === 'name' && 'License'
                              }
                            </div>
                          </td>
                          <td>&nbsp;</td>
                          <td style={{ paddingTop: '5px' }}>
                            <div className="edit_box not">
                              {item.selected[0]}
                            </div>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {
                              item.created === 0 ? (
                                '-'
                              ) : (
                                item.created
                              )
                            }
                          </td>
                          <td style={{ paddingTop: '5px' }}>
                            {
                              this.props.state.user.isAdmin ? (
                                <a
                                  className="red_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                  onKeyUp={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              ) : (
                                <a
                                  className="red_button"
                                  style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              )
                            }
                          </td>
                        </tr>
                      );
                    })
                  }
                  {
                    category.indexOf('litigator') > -1
                    && conditionList.map((item, i) => {
                      return (
                        <tr key={uuidv4()}>
                          <td style={{ paddingTop: '5px' }}>
                            <div className="edit_box not">
                              {
                                item.selected[0] === 'mchardy' && 'McHardy'
                              }
                              {
                                item.selected[0] === 'sfc' && 'SFC'
                              }
                              {
                                item.selected[0] === 'patents' && 'Patent Module'
                              }
                            </div>
                          </td>
                          <td>&nbsp;</td>
                          <td>&nbsp;</td>
                          <td style={{ textAlign: 'center' }}>
                            {
                              item.created === 0 ? (
                                '-'
                              ) : (
                                item.created
                              )
                            }
                          </td>
                          <td style={{ paddingTop: '5px' }}>
                            {
                              this.props.state.user.isAdmin ? (
                                <a
                                  className="red_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                  onKeyUp={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              ) : (
                                <a
                                  className="red_button"
                                  style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              )
                            }
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
          {
            assignedProjects.length !== 0 ? (
              <div className="setting_popup_content_wrap">
                <h4 className="content_title">{translate('settings.list.applied_projects')}</h4>
                <div className="setting_popup_content">
                  <table
                    className="table table_type_3"
                    style={{
                      tableLayout: 'fixed', padding: '0px 10px', border: '1px solid rgb(229, 229, 229)', borderRadius: '5px'
                    }}
                  >
                    <colgroup>
                      <col style={{ width: '35%' }} />
                      <col style={{ width: '15%' }} />
                      <col style={{ width: '15%' }} />
                      <col style={{ width: '15%' }} />
                      <col style={{ width: '20%' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>{translate('list.title.project_name')}</th>
                        <th>{translate('list.title.policy')}</th>
                        <th>{translate('settings.list.members')}</th>
                        <th>{translate('list.title.owner')}</th>
                        <th>{translate('settings.list.applied')}</th>
                      </tr>
                      {
                        assignedProjects.map((list) => {
                          return (
                            <tr key={uuidv4()}>
                              <td>{list.name}</td>
                              <td>
                                {
                                  list.policy_count !== 0 ? (
                                    <Popup
                                      trigger={(
                                        <span
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            return this.getsProjectPolicyDetail(list.id);
                                          }}
                                          onKeyUp={() => {
                                            return this.getsProjectPolicyDetail(list.id);
                                          }}
                                        >
                                          {list.policy_count}
                                        </span>
                                      )}
                                      on="click"
                                      hideOnScroll
                                      position="bottom left"
                                      open={
                                        popupStatus.policyPopup && activeIndex === list.id
                                      }
                                      onClose={this.handlePopupClose}
                                    >
                                      <List>
                                        {
                                          this.state.assignedPolicies.company_policy_list.length !== 0 ? (
                                            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                              <List.Header style={{ margin: '0 0 5px 0' }}>
                                                {translate('settings.list.company_policy')}
                                                (
                                                {this.state.assignedPolicies.company_policy_list.length}
                                                )
                                              </List.Header>
                                              <List.List>
                                                {
                                                  this.state.assignedPolicies.company_policy_list.map((company) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="ban" />
                                                        <List.Content>{company}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List.List>
                                            </List.Item>
                                          ) : null
                                        }
                                        {
                                          this.state.assignedPolicies.project_policy_list.length !== 0 ? (
                                            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                              <List.Header style={{ margin: '0 0 5px 0' }}>
                                                {translate('settings.list.project_policy')}
                                                (
                                                {this.state.assignedPolicies.project_policy_list.length}
                                                )
                                              </List.Header>
                                              <List.List>
                                                {
                                                  this.state.assignedPolicies.project_policy_list.map((project) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="ban" />
                                                        <List.Content>{project}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List.List>
                                            </List.Item>
                                          ) : null
                                        }
                                      </List>
                                    </Popup>
                                  ) : (
                                    list.policy_count
                                  )
                                }
                              </td>
                              <td>
                                {list.member_count !== 0 ? (
                                  <Popup
                                    trigger={(
                                      <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          return this.getsProjectPolicyMemberDetail(list.id);
                                        }}
                                        onKeyUp={() => {
                                          return this.getsProjectPolicyMemberDetail(list.id);
                                        }}
                                      >
                                        {list.member_count}
                                      </span>
                                    )}
                                    on="click"
                                    position="bottom left"
                                    hideOnScroll
                                    open={
                                      popupStatus.memberPopup && activeIndex === list.id
                                    }
                                    onClose={this.handlePopupClose}
                                  >
                                    <List>
                                      {
                                        this.state.assignedMembers.group_list.length !== 0 ? (
                                          <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                            <List.Header style={{ margin: '0 0 5px 0' }}>
                                              {translate('settings.list.group')}
                                              (
                                              {this.state.assignedMembers.group_list.length}
                                              )
                                            </List.Header>
                                            <List.List>
                                              {
                                                this.state.assignedMembers.group_list.map((group) => {
                                                  return (
                                                    <List.Item key={uuidv4()}>
                                                      <List.Icon name="group" />
                                                      <List.Content>{group}</List.Content>
                                                    </List.Item>
                                                  );
                                                })
                                              }
                                            </List.List>
                                          </List.Item>
                                        ) : null
                                      }
                                      {
                                        this.state.assignedMembers.member_list.length !== 0 ? (
                                          <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                            <List.Header style={{ margin: '0 0 5px 0' }}>
                                              {translate('settings.list.user')}
                                              (
                                              {this.state.assignedMembers.member_list.length}
                                              )
                                            </List.Header>
                                            <List.List>
                                              {
                                                this.state.assignedMembers.member_list.map((member) => {
                                                  return (
                                                    <List.Item key={uuidv4()}>
                                                      <List.Icon name="user" />
                                                      <List.Content>{member}</List.Content>
                                                    </List.Item>
                                                  );
                                                })
                                              }
                                            </List.List>
                                          </List.Item>
                                        ) : null
                                      }
                                    </List>
                                  </Popup>
                                ) : (
                                  list.member_count
                                )}
                              </td>
                              <td>{list.owner}</td>
                              <td>{list.assigned}</td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null
          }
          <div className="setting_popup_content_wrap" style={{ marginBottom: '100px' }}>
            <h4 className="content_title">{translate('settings.list.created_by')}</h4>
            <div className="setting_popup_content">
              <table
                className="table table_type_3"
                style={{
                  tableLayout: 'fixed', padding: '0px 10px', border: '1px solid rgb(229, 229, 229)', borderRadius: '5px'
                }}
              >
                <colgroup>
                  <col style={{ width: '30%' }} />
                  <col style={{ width: '30%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '20%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>{translate('settings.list.user_name')}</th>
                    <th>{translate('settings.list.email')}</th>
                    <th>{translate('settings.list.assigned_group')}</th>
                    <th>{translate('settings.list.applied')}</th>
                  </tr>
                  {
                    owner
                      && (
                        <tr>
                          <td>{owner.profile}</td>
                          <td>{this.convertToString(owner.email)}</td>
                          <td>{owner.assigned}</td>
                          <td>{owner.assigned}</td>
                        </tr>
                      )
                  }
                </tbody>
              </table>
            </div>
            <div className="setting_popup_content" style={{ marginTop: '50px' }}>
              <table className="table" style={{ tableLayout: 'fixed' }}>
                <colgroup>
                  <col style={{ width: '30%' }} />
                  <col style={{ width: '70%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>
                      <h5>{translate('settings.list.created_date')}</h5>
                      <div className="setting_popup_content" style={{ marginTop: '0' }}>
                        {
                          info.created && <div className="text_box">{info.created}</div>
                        }
                      </div>
                    </td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{translate('modal.cve.last_modified_date')}</h5>
                      <div className="setting_popup_content" style={{ marginTop: '0' }}>
                        {
                          info.last_modified && <div className="text_box">{info.last_modified}</div>
                        }
                      </div>
                    </td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="setting_popup_bottom">
            {
              this.props.state.user.isAdmin ? (
                <a className="red" style={{ cursor: 'pointer', lineHeight: '15px' }} onClick={this.handleRemovePolicy} onKeyUp={this.handleRemovePolicy}>
                  {translate('settings.list.delete_this_policy')}
                </a>
              ) : (
                <a
                  className="red"
                  style={{
                    pointerEvents: 'none',
                    cursor: 'default',
                    opacity: '.45',
                    lineHeight: '15px',
                  }}
                >
                  {translate('settings.list.delete_this_policy')}
                </a>
              )
            }
            {
              hasJira ? (
                <a
                  className="red"
                  style={{ cursor: 'pointer', lineHeight: '15px', marginLeft: '15px' }}
                  onClick={this.handleRemoveJira}
                  onKeyUp={this.handleRemoveJira}
                >
                  {translate('settings.list.delete_jira_settings')}
                </a>
              ) : null
            }
          </div>
        </div>
      );
    };

    const getModalBtn = () => {
      if (this.props.state.user.isAdmin) {
        return (
          <div className="setting_popup_button_wrap">
            <a
              className="button cencel_button"
              style={{ cursor: 'pointer' }}
              onClick={this.closeEditPolicyModal}
              onKeyUp={this.closeEditPolicyModal}
            >
              {translate('modal.button.cancel')}
            </a>
            <a
              className="button save_button"
              style={{ cursor: 'pointer' }}
              onClick={this.handleSave}
              onKeyUp={this.handleSave}
            >
              {translate('modal.button.save')}
            </a>
          </div>
        );
      }
      return (
        <div className="setting_popup_button_wrap">
          <a
            className="button save_button center_button"
            style={{ cursor: 'pointer' }}
            onClick={this.closeEditPolicyModal}
            onKeyUp={this.closeEditPolicyModal}
          >
            {translate('modal.button.close')}
          </a>
        </div>
      );
    };

    return (
      <Modal open={isOpenMEP} onClose={this.closeEditPolicyModal}>
        <div className="setting_popup default_popup has_popup_inner_menu">
          <div className="setting_popup_header">
            <h2 className="popup_name">{translate('settings.list.policy_detail')}</h2>
            {
              hasJira ? (
                <div className="edit_button_wrap">
                  <Button
                    className="jira"
                    onClick={this.handleMCIOpen}
                    onKeyUp={this.handleMCIOpen}
                  >
                    <span className="icon-wrap">
                      <img className="icon-jira" src={JiraLogo} alt="" />
                    </span>
                    {translate('settings.list.edit_jira_settings')}
                  </Button>
                </div>
              ) : (
                <div className="edit_button_wrap">
                  <Button
                    className="jira"
                    onClick={this.handleMCIOpen}
                    onKeyUp={this.handleMCIOpen}
                  >
                    <span className="icon-wrap">
                      <img className="icon-jira" src={JiraLogo} alt="" />
                    </span>
                    {translate('settings.list.create_jira_settings')}
                  </Button>
                </div>
              )
            }
            <a
              className="popup_close_button"
              onClick={this.closeEditPolicyModal}
              onKeyUp={this.closeEditPolicyModal}
            >
              <img src={closeBtn} alt="" />
            </a>
            <div className="popup_inner_menu" style={{ width: '97%' }}>
              <a className="active" style={{ cursor: 'initial' }}>
                {translate('settings.list.policy_information')}
              </a>
            </div>
          </div>
          <Scrollbars
            style={{
              position: 'relative',
              overflow: 'hidden',
              height: '100%',
            }}
            onScroll={this.handleScroll}
          >
            {getModalContent()}
          </Scrollbars>
          {
            isLoading ? null : getModalBtn()
          }
        </div>
        <Modal open={this.state.modalAlert} onClose={this.closeAlertModal}>
          {this.state.isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.state.modalAlertTitle}</h2>
                  <p className="text">{this.state.modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      onClick={this.closeAlertModal}
                      onKeyUp={this.closeAlertModal}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
        <Modal open={this.state.isWarnModal} onClose={this.closeWarnModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.state.modalWarnTitle}</h2>
                <p className="text">{this.state.modalWarnMsg}</p>
                <div className="button_wrap">
                  <a
                    className="left_button"
                    onClick={this.closeWarnModal}
                    onKeyUp={this.closeWarnModal}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="right_button"
                    onClick={this.handleChange}
                    onKeyUp={this.handleChange}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={isOpenMDP} onClose={this.closeDeletePolicyModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{translate('settings.message.delete_policy')}</p>
                <div className="button_wrap">
                  <a className="left_button" onClick={this.closeDeletePolicyModal} onKeyUp={this.closeDeletePolicyModal}>
                    {translate('modal.button.cancel')}
                  </a>
                  <a className="right_button" onClick={this.deletesPolicyDetail} onKeyUp={this.deletesPolicyDetail}>
                    {translate('modal.button.delete')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={isOpenMDJ} onClose={this.closeDeleteJiraModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  isModalLoading ? (
                    <div className="button_wrap">
                      <a
                        className="center_button"
                        onClick={this.closeDeleteJiraModal}
                        onKeyUp={this.closeDeleteJiraModal}
                      >
                        {translate('modal.button.ok')}
                      </a>
                    </div>
                  ) : (
                    <div className="button_wrap">
                      <a className="left_button" onClick={this.closeDeleteJiraModal} onKeyUp={this.closeDeleteJiraModal}>
                        {translate('modal.button.cancel')}
                      </a>
                      <a className="right_button" onClick={this.deleteJiraIssueWithPolicy} onKeyUp={this.deleteJiraIssueWithPolicy}>
                        {translate('modal.button.delete')}
                      </a>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </Modal>
        <CreateJiraIssueModal
          isOpenMCI={isOpenMCI}
          selectedPolicyId={policyId}
          closeModal={this.handleMCIClose}
          completeCallback={this.handleJiraIssueCallback}
          translate={translate}
        />
      </Modal>
    );
  }
}

export default withTranslation()(inject('state')(observer(EditPolicyModal)));
